import { render } from "./Slogan2.vue?vue&type=template&id=930cec2c&scoped=true&lang=true"
import script from "./Slogan2.vue?vue&type=script&lang=js"
export * from "./Slogan2.vue?vue&type=script&lang=js"

import "./Slogan2.vue?vue&type=style&index=0&id=930cec2c&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-930cec2c"]])

export default __exports__